export const CreateFundActionTypes = {
  CREATE_FUND_LOADING: "CREATE_FUND_LOADING",
  CREATE_FUND_ERROR: "CREATE_FUND_ERROR",
  CREATE_FUND_SUCCESS: "CREATE_FUND_SUCCESS",
};
